<app-message-box [show]="show"
                 (onChange)="onChange($event)">
  <div class="message-container mt-1-rem" showmessage>
    <app-button icon="warning" (onClick)="onShow()">{{ 'data_sources.custom_imports.show_file_structure' | translate }}</app-button>
  </div>
  <div class="message-container mt-1-rem">
    <ng-content></ng-content>
  </div>
  <div class="dimensions-container">
    <div class="warning-item">
      <mat-icon class="material-icons-outlined">analytics</mat-icon>
      <strong>{{ 'data_sources.dimensions' | translate }}</strong>
    </div>
    <ul>
      <li *ngFor="let dimension of datasource.datasetUsageCustomConfiguration$.value.dimensions$ | async">
        <app-source [item]="dimension.item$.value.payload"
                    [enableTooltip]="false"
                    [enableName]="false">
          <div class="display-flex flex-align-center gap-0-5em">
            <strong>{{ dimension.item$.value.payload.attributes.name }}</strong>
            <app-badge customToolTip [contentTemplate]="dimensionTooltip">
              <mat-icon class="material-icons-outlined">view_column</mat-icon>
              <span>{{ 'data_sources.custom_imports.column' | translate | lowercase }}: {{ dimension.payload.ext_name }}</span>
              <ng-container *ngIf="dimension.ext_format$ | async">
                <span>/</span>
                <span>format: {{ dimension.ext_format$ | async }}</span>
              </ng-container>
              <mat-icon class="material-icons-outlined icon-hover">info</mat-icon>
            </app-badge>
            <ng-template #dimensionTooltip>
              <div>{{ 'data_sources.custom_imports.column' | translate }}: {{ dimension.payload.ext_name }}</div>
              <div *ngIf="dimension.payload.ext_format">{{ 'data_sources.custom_imports.format' | translate }}: {{ dimension.ext_format$ | async }}</div>
            </ng-template>
          </div>
        </app-source>
      </li>
    </ul>
  </div>
  <div class="metrics-container">
    <div class="warning-item">
      <mat-icon class="material-icons-outlined">analytics</mat-icon>
      <strong>{{ 'data_sources.metrics' | translate }}</strong>
    </div>
    <ul>
      <li *ngFor="let metric of datasource.datasetUsageCustomConfiguration$.value.metrics$ | async">
        <app-source [item]="metric.item$.value.payload"
                    [enableTooltip]="false"
                    [enableName]="false">
          <div class="display-flex flex-align-center gap-0-5em">
            <strong>{{ metric.item$.value.payload.attributes.name }}</strong>
            <app-badge customToolTip [contentTemplate]="metricTooltip">
              <mat-icon class="material-icons-outlined">view_column</mat-icon>
              <span>{{ 'data_sources.custom_imports.column' | translate | lowercase }}: {{ metric.payload.ext_name }}</span>
              <span>/</span>
              <span>format: {{ metric.ext_format$ | async }}</span>
              <mat-icon class="material-icons-outlined icon-hover">info</mat-icon>
            </app-badge>
            <ng-template #metricTooltip>
              <div>{{ 'data_sources.custom_imports.column' | translate }}: {{ metric.payload.ext_name }}</div>
              <div>Format: {{ metric.item$.value.payload.attributes.format_type }}</div>
              <ng-container *ngIf="metric.payload.ext_format">
                <div *ngIf="metric.payload.ext_format.dec_sep">{{ 'data_sources.custom_imports.dec_sep' | translate }}: {{ metric.payload.ext_format.dec_sep === 'null' && 'data_sources.custom_imports.none' || metric.payload.ext_format.dec_sep | translate }}</div>
                <div *ngIf="metric.payload.ext_format.tsd_sep">{{ 'data_sources.custom_imports.tsd_sep' | translate }}: {{ metric.payload.ext_format.tsd_sep === 'null' && 'data_sources.custom_imports.none' || metric.payload.ext_format.tsd_sep | translate }}</div>
              </ng-container>
            </ng-template>
          </div>
        </app-source>
      </li>
    </ul>
  </div>
  <div class="mb-0-2-rem warning-item">
    <mat-icon class="material-icons-outlined">description</mat-icon>
    <strong>{{ 'data_sources.custom_imports.file_type' | translate }}:</strong>
    <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.file_type }}</span>
  </div>
  <div class="mb-0-2-rem warning-item"
       *ngIf="datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.file_separator">
    <mat-icon class="material-icons-outlined">text_snippet</mat-icon>
    <strong>{{ 'data_sources.custom_imports.file_separator' | translate }}:</strong>
    <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.file_separator }}</span>
  </div>
  <div class="mb-0-2-rem warning-item">
    <mat-icon class="material-icons-outlined">table_rows</mat-icon>
    <strong>{{ 'data_sources.custom_imports.header_line' | translate }}: </strong>
    <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.headers_line }}</span>
  </div>
  <ng-container *ngIf="(datasource.datasetUsageCustomConfiguration$.value.date_mode$ | async) === 'file_name'">
    <div class="display-flex flex-align-center gap-0-5em mt-1em warning-item">
      <mat-icon class="material-icons-outlined">warning</mat-icon>
      <strong>{{ 'data_sources.custom_imports.date_info' | translate }}</strong>
    </div>
  </ng-container>
</app-message-box>
